import { render, staticRenderFns } from "./IconSun.vue?vue&type=template&id=53a37fb3&"
import script from "./IconSun.vue?vue&type=script&lang=js&"
export * from "./IconSun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports